/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./Footer.scss";

import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { NavLink as RouteLink, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import visaCard from "../../assets/img/visa.png";
import MasterCard from "../../assets/img/MasterCard.png"; // Add Mastercard image
// import amazonCard from "../../assets/img/amazon.png";
import rupayCard from "../../assets/img/rupay.png";
import paypalCard from "../../assets/img/paytm.png";
import Logo from "../../assets/img/svg/mommas.svg";
import AppStore from '../../assets/img/appstore.png';
import Gplay from '../../assets/img/gplay.png';

import { useSelector, useDispatch } from "react-redux";
import { LoginModalOpenAction, URLRedirectAction } from "../../redux/LoginModal";
import CustomerServices from "../../services/CustomerServices";

export default function Footer() {
  const [socials, setSocials] = useState([]);

  const emailId = useSelector((state) => state.auth.emailId);
  const hostUrl = useSelector((state) => state.config.config.hostUrl);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    getSocials();
  }, []);

  const onOptionClick = (url) => {
    if (emailId) {
      navigate(url);
    } else {
      dispatch(LoginModalOpenAction());
      dispatch(URLRedirectAction(url));
    }
  };

  const getSocials = () => {
    const details = {};
    axios
      .all([CustomerServices.getSocials(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let socials = resData.data ? resData.data : {};
            socials = socials.data ? socials.data : [];
            setSocials(socials);
          }
        }
      })
      .catch(function (res) {
        console.log(res);
      });
  };

  const handleSubscribe = () => {
    const input = document.querySelector('.subscribe_form input[name="email"]');
    const email = input?.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (!email) return alert("Please enter an email");
    if (!emailRegex.test(email)) return alert("Please enter a valid email");
  
    alert(`The email ${email} has been subscribed successfully!`);
    input.value = ""; // Clear input
  };
  

  const scrollToGetApp = () => {
    const element = document.querySelector('.app-div-heading'); // Heading for Get The App section
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };
  
  

  return (
    <div className="footer-main">
      <div className="footer-top footer-padding">
        <div className="container-fluid">
          <div className="row">
            {/* Icon Boxes */}
            <div className="col-md-2 col-sm-4 col-6 mb-sm-20">
              <div className="icon-box">
                <span className="text-light-green">
                  <i className="flaticon-credit-card-1"></i>
                </span>
                <span className="text-custom-white">
                  100% Payment
                  <br />
                  Secured
                </span>
              </div>
            </div>
            <div className="col-md-3 col-sm-4 col-6 mb-sm-20">
              <div className="icon-box">
                <span className="text-light-green">
                  <i className="flaticon-wallet-1"></i>
                </span>
                <span className="text-custom-white">
                  Support lots
                  <br /> of Payments
                </span>
              </div>
            </div>
            <div className="col-md-2 col-sm-4 col-6 mb-sm-20">
              <div className="icon-box">
                <span className="text-light-green">
                  <i className="flaticon-help"></i>
                </span>
                <span className="text-custom-white">
                  24 hours / 7 days
                  <br />
                  Support
                </span>
              </div>
            </div>
            {/* <div className="col-md-2 col-sm-4 col-6">
              <div className="icon-box">
                <span className="text-light-green">
                  <i className="flaticon-truck"></i>
                </span>
                <span className="text-custom-white">
                  Free Delivery
                  <br />
                  with $50
                </span>
              </div>
            </div> */}
            <div className="col-md-2 col-sm-4 col-6">
              <div className="icon-box">
                <span className="text-light-green">
                  <i className="flaticon-guarantee"></i>
                </span>
                <span className="text-custom-white">
                  Best Price
                  <br />
                  Guaranteed
                </span>
              </div>
            </div>
            <div className="col-md-3 col-sm-4 col-6">
              <div className="icon-box">
                <span className="text-light-green">
                  <i className="flaticon-app-file-symbol"></i>
                </span>
                <span className="text-custom-white">
                  Mobile Apps
                  <br />
                  Ready
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="section-padding bg-light-theme pt-0 u-line footer-bg">
        <div className="container-fluid">
          <div className="row">
            {/* Logo + About */}
            <div className="col-xl col-lg-4 col-md-4 col-sm-6">
              <div className="footer-logo d-flex">
                <img src={Logo} alt="Logo" style={{ width: 60, height: 60 }} />
                <h3 className="header-logo">
                  Momma's <span style={{ color: "#ff6602" }}>Kitchen</span>
                </h3>
              </div>
              <p className="footer-logo-text" style={{fontStyle:"italic"}}>
              Relish; don't just eat
              </p>
            </div>

            {/* Get to Know Us */}
            <div className="col-xl col-lg-4 col-md-4 col-sm-6">
              <div className="footer-links">
                <h6 className="text-custom-white">Get to Know Us</h6>
                <ul className="footer-ul-div">
                  <li>
                    <RouteLink to={"/about"} className="text-white fw-600">
                      About Us
                    </RouteLink>
                  </li>
                </ul>
              </div>
            </div>

            {/* Let Us Help You */}
            <div className="col-xl col-lg-4 col-md-4 col-sm-6">
              <div className="footer-links">
                <h6 className="text-custom-white">Let Us Help You</h6>
                <ul className="footer-ul-div">
                  <li>
                    <span
                      onClick={() => onOptionClick("/profile")}
                      className={`text-white fw-600 ${pathname === "/profile" ? "active" : ""}`}
                      style={{ cursor: "pointer" }}
                    >
                      Account Details
                    </span>
                  </li>
                  <li>
                    <span
                      onClick={() => onOptionClick("/orders")}
                      className={`text-white fw-600 ${pathname === "/orders" ? "active" : ""}`}
                      style={{ cursor: "pointer" }}
                    >
                      Order History
                    </span>
                  </li>
                  <li>
                    <RouteLink to={"/search-results"} className="text-white fw-600">
                      Find restaurant
                    </RouteLink>
                  </li>
                </ul>
              </div>
            </div>

            {/* Doing Business */}
            <div className="col-xl col-lg-4 col-md-4 col-sm-6">
              <div className="footer-links">
                <h6 className="text-custom-white">Doing Business</h6>
                <ul className="footer-ul-div">
                  <li>
                    <RouteLink
                      to={"/registration"}
                      className="text-white fw-600"
                    >
                      Become a host/provider with us
                    </RouteLink>
                  </li>
                  {!emailId && (
                    <li>
                      <RouteLink
                        to={"/registration"}
                        className="text-white fw-600"
                      >
                        Create an Account
                      </RouteLink>
                    </li>
                  )}
                  <li>
                    <RouteLink to={"/help"} className="text-white fw-600">
                      Help
                    </RouteLink>
                  </li>
                  <li>
                    <RouteLink to={"/terms-and-conditions"} className="text-white fw-600">
                      Terms & Conditions
                    </RouteLink>
                  </li>
                </ul>
              </div>
            </div>

            {/* Download Apps */}
            <div className="col-xl col-lg-4 col-md-4 col-sm-6">
              <div className="footer-links">
                <h6 className="text-custom-white">Download Apps</h6>
                <div className="appimg">
  <a onClick={scrollToGetApp}>
    <img src={AppStore} className="img-fluid" alt="App Store" />
  </a>
</div>
<div className="appimg">
  <a onClick={scrollToGetApp}>
    <img src={Gplay} className="img-fluid" alt="Google Play" />
  </a>
</div>

              </div>
            </div>

            {/* Newsletter */}
            <div className="col-xl col-lg-4 col-md-4 col-sm-6">
              <div className="footer-contact">
                <h6 className="text-custom-white">Newsletter</h6>
                <form className="subscribe_form">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control form-control-submit"
                      name="email"
                      placeholder="Enter your email"
                    />
                    <span>
                      <button
                        className="btn btn-second btn-submit news-letter-btn"
                        type="button"
                        onClick={handleSubscribe}
                      >
                        <i className="fas fa-paper-plane"></i>
                      </button>
                    </span>
                  </div>
                </form>
              </div>
            </div>

            {/* Socials */}
            <div className="col-md-12">
              <div className="ft-social-media">
                <h6 className="text-center text-white">
                  <a onClick={scrollToGetApp} className="text-white">Follow us</a>
                </h6>
                <ul>
                  {socials &&
                    socials.length > 0 &&
                    socials.map((eachSocial, index) => (
                      <li key={index}>
                        <a href={eachSocial.url} target="_blank" rel="noreferrer">
                          <i className={eachSocial.icon}></i>
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Copyright + Made with DEzen + Payment */}
      <div className="copyright bg-black">
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* Bottom-left */}
            <div className="col-lg-4 mb-2 mb-lg-0">
              <div className="payment-logo">
                <span className="text-white fs-14 me-3">We accept</span>
                <div className="payment-icon d-flex">
                  <div className="credit-card-accept">
                    <img src={visaCard} alt="Visa" />
                  </div>
                  <div className="credit-card-accept">
                    <img src={MasterCard} alt="Mastercard" />
                  </div>
                  <div className="credit-card-accept">
                    <img src={rupayCard} alt="Rupay" />
                  </div>
                  <div className="credit-card-accept">
                    <img src={paypalCard} alt="Paypal" />
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom-center */}
            <div className="col-lg-4 text-center mb-2 mb-lg-0 medewithlove">
              <span className="text-custom-white">
                Made with <i className="fas fa-heart"></i> DEzen
              </span>
            </div>

            {/* Bottom-right */}
            <div className="col-lg-4 text-lg-end">
              <div className="copyright-text">
                <span className="text-white">© H Bros Ltd - 2024 | All Rights Reserved</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
